import { WorkflowSearchBean } from './WorkflowSearchBean';

export class PageRules {
  direction: string = 'DESC'; // 升降排序
  fromClientType: string;
  number: number; // 当前页
  property: string = 'createdDate'; // 搜索的字段
  rules: RulesConfig[];
  size: number; //当前页数据多少条
  specialConditions: any;
  workflowSearchBean?: WorkflowSearchBean;

  public constructor(init?: Partial<PageRules>) {
    Object.assign(this, init);
  }
}

export interface RulesConfig {
  field: string; // 搜索字段
  option: string; //
  values?: Object[]; // 值
  collectIndex?: number;
}
